import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { PayBillService } from '../data-services/pay-bill.service';
import { PolicyDataService } from '../data-services/policy-data.service';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root',
})
export class BillingPaymentService {
  private accountID: string;
  private policyCheckDigits: string;
  private xmlResp: any;

  constructor(
    private paybillService: PayBillService,
    private policyDataService: PolicyDataService,
  ) {}

  makePayment(policyNumber, zipCode, minAmount) {
    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        const policy = policyResponse
                        .filter(policyDetails => policyDetails.policynumber.policyNumber === policyNumber)[0];
        const accountId = policy?.as400AccountId
        const checkDigit = policy?.checkDigits
      
        this.accountID = accountId;
        this.policyCheckDigits = `${policyNumber}${checkDigit}`;
        this.xmlResp = this.createXMLBody(
          accountId,
          zipCode,
          Number(minAmount).toFixed(2)
        );
        if (Capacitor.isNativePlatform()) {
          this.paybillService.setVal(
            accountId,
            this.policyCheckDigits,
            this.xmlResp
          );
          Browser.open({
            url: `${environment.ui_url}/pay-bill/${encodeURIComponent(
              btoa(this.xmlResp)
            )}/${encodeURIComponent(btoa(this.policyCheckDigits))}`,
          });
        } else {
          this.payBill();
        }
      }
    });
  }

  payBill() {
    const mapForm = document.createElement('form');
    mapForm.setAttribute('style', 'display: none');
    mapForm.setAttribute('target', '_blank');
    mapForm.method = 'POST';
    mapForm.action = environment.paybill_link;

    const mapInput = document.createElement('input');
    mapInput.setAttribute('type', 'text');
    mapInput.setAttribute('name', 'txtMiscellaneous');
    mapInput.setAttribute('value', this.xmlResp);
    mapForm.appendChild(mapInput);

    const mapInput2 = document.createElement('input');
    mapInput2.setAttribute('type', 'text');
    mapInput2.setAttribute('name', 'txtAcctNumber');
    mapInput2.setAttribute('value', this.policyCheckDigits);
    mapForm.appendChild(mapInput2);

    const mapInput3 = document.createElement('input');
    mapInput3.setAttribute('type', 'text');
    mapInput3.setAttribute('name', 'txtSource');
    mapInput3.setAttribute('value', 'mapfrecweb!01122');
    mapForm.appendChild(mapInput3);

    document.body.appendChild(mapForm);
    mapForm.submit();
    document.body.removeChild(mapForm);
  }

  createXMLBody(accountID, zipCode, minAmount) {
    const xmlResp = `
    <MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmount}</MinDue></MiscellaneousData>
    `;
    return xmlResp;
  }
}
